// src/components/Auth/LoginForm.js
import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios'; // Tu instancia de Axios
import { useAuth } from '../../context/AuthContext';
import { Snackbar, Alert } from '@mui/material';



function LoginForm() {
    const [numeroApartamento, setNumeroApartamento] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth(); // Esto trae la función login de tu contexto

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/calendar'); // o "/" si querés redirigir al home
        }
    }, [navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(''); // limpia error anterior

        const loginResult = await login(numeroApartamento, password);

        if (loginResult.success) {
            if (loginResult.mustChangePassword) {
                navigate('/change-password');
            } else {
                navigate('/calendar');
            }
        } else {
            console.log('Mensaje de error recibido:', loginResult.message);
            setError(loginResult.message);
        }
    };


    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
                margin="normal"
                required
                fullWidth
                id="numeroApartamento"
                label="Número de Apartamento"
                name="numeroApartamento"
                autoComplete="apartment-number"
                autoFocus
                value={numeroApartamento}
                onChange={(e) => setNumeroApartamento(e.target.value)}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <Snackbar
                open={!!error}
                autoHideDuration={4000}
                onClose={() => setError('')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="error" sx={{ width: '100%' }}>
                    {error}
                </Alert>
            </Snackbar>

            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
            >
                Iniciar Sesión
            </Button>
            {/* <Typography variant="body2" sx={{ textAlign: 'center' }}>
                ¿No tienes cuenta?{' '}
                <Link to="/register" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button variant="text" color="primary" sx={{ p: 0, minWidth: 0 }}>
                        Regístrate aquí
                    </Button>
                </Link>
            </Typography> */}
        </Box>
    );
}

export default LoginForm;